import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getClient,
  getIdClient,
  createClient,
  updateClient,
  deleteClient,
  createOfficeMapping,
  deleteOfficeMaping,
  getClientMaster,
} from "./clientAPI";
import { createOffice } from "../office/officeAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  permissionClient: [],
};

export const fetchClient = createAsyncThunk(
  "Client/fetchClient",
  async (payload) => {
    const response = await getClient(payload);
    return response;
  }
);

export const fetchClientMaster = createAsyncThunk(
  "Client/fetchClientMaster",
  async (payload) => {
    const response = await getClientMaster(payload);
    return response;
  }
);


export const addClient = createAsyncThunk(
  "Client/addClient",
  async (payload) => {
    const response = await createClient(payload);
    return response;
  }
);

export const editClient = createAsyncThunk(
  "Client/editClient",
  async (payload) => {
    const response = await updateClient(payload);
    return response;
  }
);

export const fetchIdClient = createAsyncThunk(
  "Client/fetchIdClient",
  async (id) => {
    const response = await getIdClient(id);
    return response;
  }
);

export const removeClient = createAsyncThunk(
  "Client/removeClient",
  async (payload) => {
    const response = await deleteClient(payload);
    return response;
  }
);

export const removeOfficeMapping = createAsyncThunk(
  "Client/removeOfficeMapping",
  async (payload) => {
    const response = await deleteOfficeMaping(payload);
    return response;
  }
);

export const addOfficeMapping = createAsyncThunk(
  "Client/addOfficeMapping",
  async (payload) => {
    const response = await createOfficeMapping(payload);
    return response;
  }
);

export const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermissionClient: (state, action) => {
      state.permissionClient = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClient.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchClient.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchClientMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchClientMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdClient.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdClient.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addClient.pending, (state) => {
        state.loading = true;
      })
      .addCase(addClient.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editClient.pending, (state) => {
        state.loading = true;
      })
      .addCase(editClient.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeClient.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeClient.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeOfficeMapping.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeOfficeMapping.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addOfficeMapping.pending, (state) => {
        state.loading = true;
      })
      .addCase(addOfficeMapping.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setPermissionClient,
} = clientSlice.actions;

export const selectClient = (state) => state.client.data;
export const selectIdClient = (state) => state.client.dataId;
export const selectLoading = (state) => state.client.loading;
export const selectError = (state) => state.client.error;
export const selectPageNo = (state) => state.client.pageNo;
export const selectPageSize = (state) => state.client.pageSize;
export const selectTotalRecord = (state) => state.client.totalRecord;
export const selectSelected = (state) => state.client.selected;
export const selectResult = (state) => state.client.result;
export const selectPermissionClient = (state) => state.client.permissionClient;

export default clientSlice.reducer;
